import React, { memo } from "react";
import Input from "./Input/Input";
import Password from "./Password/Password";
import Select from "./Select/Select";
import FileInput from "./FileInput/FileInput";
import Checkbox from "./Checkbox/Checkbox";
import FieldArray from "./FieldArray/FieldArray";
import Range from "./Range/Range";
import TextArea from "./TextArea/TextArea";
import Markdown from "./MarkdownEditor/Markdown";

interface IControlProps {
  controlType:
    | "input"
    | "password"
    | "select"
    | "file"
    | "checkbox"
    | "fieldArray"
    | "range"
    | "markdown"
    | "textarea";
  errorMessage?: string | undefined;
  isRequired?: boolean | undefined;
  [key: string]: any;
}

const FormControl: React.FC<IControlProps> = ({ controlType, ...rest }) => {
  const props = rest as any;
  switch (controlType) {
    case "input":
      return <Input {...props} controlType={controlType} />;
    case "password":
      return <Password {...props} controlType={controlType} />;
    case "textarea":
      return <TextArea {...props} controlType={controlType} />;
    case "select":
      return <Select {...props} controlType={controlType} />;
    case "file":
      return <FileInput {...props} controlType={controlType} />;
    case "checkbox":
      return <Checkbox {...props} controlType={controlType} />;
    case "fieldArray":
      return <FieldArray {...props} controlType={controlType} />;
    case "range":
      return <Range {...props} controlType={controlType} />;
    case "markdown":
      return <Markdown {...props} controlType={controlType} />;
    default:
      return null;
  }
};

export default memo(FormControl);
